import React, { useState }from "react";
import { Button, Modal, Form, Input, Select, message } from "antd";
import _ from 'lodash';
import styled from "styled-components";

const ForgotPasswordModal = ({ visible, onClose, loginPath, Auth, loginValues }) => {

  const [loading, setLoading] = useState(false);
  const [validationType, setValidationType] = useState('username');

  const [form] = Form.useForm();

  const onCancel = () => {
    onClose();
    setLoading(false);
    setValidationType('username')
    form.resetFields();
  }

  const handleSubmit = (formValues) => {
    setLoading(true);

    console.log(loginValues)

    const { typeValue } = formValues;
    const { server, repository } = loginValues;

    Auth.resetPassword(loginPath, typeValue, server, repository, function (res) {
      if(res.data.indexOf('emailed') > -1) {
        message.success({ content: res.data, duration: 6 });
      }
      else {
        message.error({ content: res.data, duration: 6 });
      }
      onCancel();
    })
  }

  const preventInvalidChars = (e) => {
    // allow alphanumeric, backspace, _, ', ., *
    if (e.key.match(/[^A-Za-z0-9\x08\_\'\.\*]/)) {
      e.preventDefault();
    }
  }

  const onTypeChange = (key) => {
    setValidationType(key);
		form.setFields([
			{name: ['typeValue'], errors: [], value: ""}
    ])
  }

  return (
    <Modal
      open={visible}
      width="450px"
      title='Reset Password'
      forceRender={true}
      destroyOnClose={true}
      maskClosable={false}
      onCancel={onCancel}
      footer={null}
    >
			<Message>Please enter your username or email address.</Message>
      <Form
        form={form}
        layout='inline'
        onFinish={handleSubmit}
        autoComplete="off"
        name="changePasswordForm"
        initialValues={{type: 'username'}}
        hideRequiredMark
      >
        <Form.Item
          name="type"
          style={{margin: '0'}}
        >
          <Select style={{width: '110px'}} onChange={onTypeChange}>
            <Select.Option key="username" value="username">Username</Select.Option>
            <Select.Option key="email" value="email">Email</Select.Option>
          </Select>
        </Form.Item>
        <div style={{fontSize: '16px', margin: '0 5px 0 5px'}}>=</div>
        <NoPaddingLabel>
          <Form.Item
            name="typeValue"
            rules={[
              {
                required: true,
                type: validationType === 'username' ? 'string' : 'email',
                message: validationType === 'username' ? "Username required": "Email required"
              }
            ]}
            style={{margin: '0'}}
          >
              <Input
                autoFocus
                style={{width: '100%'}}
                onKeyDown={validationType === 'username' && preventInvalidChars}
              />
          </Form.Item>
        </NoPaddingLabel>
        <Form.Item
          wrapperCol={{
            xs: { span: 24 },
            sm: { span: 24 },
          }}
          style={{ margin: '25px 0 0 0', width: '100%'}}
        >
          <Button
            type="primary"
            htmlType="submit"
            style={{ float: 'right', marginLeft: '10px' }}
            loading={loading}>
            Submit
          </Button>
          <Button
            style={{ float: 'right' }}
            onClick={onCancel}>
            Cancel
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

const Message = styled.div`
  overflow: hidden;
	font-size: 13px;
	margin-bottom: 20px;
	display: block;
`

const NoPaddingLabel = styled.div`
  width: 271px;
  .ant-form-item-label {
    padding: 0;
  }
`

export default ForgotPasswordModal;
